import React from 'react';
import classNames from 'classnames';

import styles from './cardAreaStyles.scss';

const CardArea: React.FunctionComponent<{
  children?: React.ReactNode;
  className?: string;
  heapSegment?: string;
  simple?: boolean;
  shadowless?: boolean;
}> = ({ children, className, heapSegment, simple, shadowless }) => (
  <div
    className={classNames(
      { [styles.cardContainer]: !simple, [styles.shadowlessContainer]: shadowless },
      className
    )}
    data-heap-segment={heapSegment}
  >
    {children}
  </div>
);

export default CardArea;
